import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a44be9eca334e00140dccc1_1783530539743_01a62699/amplify_1782890142587/src/app/home/components/HomeClient.tsx");
